<div class="personalWrapper"
     [style.backgroundColor]="getBgColorStyle()"
     [class.leftShadow]="menuShown"
     (click)="click();">

    <div class="userName">{{ userName }}</div>

    <div [style.display]="getDisplayedStyle()" class="personalTable">
        <div class="personalItem customerData" (click)="gotoKundendaten()">
            Meine Daten
        </div>
        <div class="personalItem logout" (click)="logOff()">
            Abmelden
        </div>
    </div>

</div>

